<template>

  <div class="news">
    <div class="inner-page-title"> Events </div>
    <div class="bg_inner_page"
      style="background-image:url(/static/cdn/pexels-jakub-novacek-924824_vi4ina.jpg)">

    </div>
    <div class="news_body">
      <div class="container">

        <div class="row">

          <!-- BODY PAGE -->
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-12">
                <div class="posts_section">
                  <router-link :to="'/news/' " class="back-bt  button button--transparent-grad pulse">
                    <span>
                      Back
                    </span>
                  </router-link>
                  <div class="page_section_header">
                    <h2 class="sc">
                      MI Events Calendar
                    </h2>
                    <p>
                    Business events are vital for raising brand awareness and connecting with clients on a personal level. Meeting with your clients face to face is the most effective approach to establish trust and demonstrate that they are your top priority.
    <br><br>
Take a look at the events list we’re planning to attend!
                    </p>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="events">
                        <h3>Upcoming Events </h3>
                        <router-link data-aos="fade-up" data-aos-once="true" data-aos-delay="100"
                          data-aos-duration="500" :to="'/news/show/'+ event.id + '/events'" class="events__event"
                          v-for="event in UpComingEvents" :key="event.id">
                          <div class="events__event__date">
                            <p class="events__event__date__day"> {{ event.date | moment("DD ") }} </p>
                            <p class="events__event__date__month">{{ event.date | moment("MMMM ") }} </p>
                          </div>
                          <div class="events__event__info">
                            <h3 v-html="event.title.rendered">
                            </h3>
                            <div class="events__event__info__cloud">
                              <img
                                src="/static/cdn/location_wqviie.svg">
                              <span v-html="event.excerpt.rendered"> </span>
                            </div>
                          </div>
                        </router-link>
                      </div>


                    </div>

                    <div class="col-sm-6">
                      <div class="events">
                        <h3>Past Events</h3>
                        <router-link data-aos="fade-up" data-aos-once="true" data-aos-delay="100"
                          data-aos-duration="500" :to="'/news/show/'+ event.id + '/events'" class="events__event"
                          v-for="event in pastEvents" :key="event.id">
                          <div class="events__event__date">
                            <p class="events__event__date__day"> {{ event.date | moment("DD ") }} </p>
                            <p class="events__event__date__month">{{ event.date | moment("MMMM ") }} </p>
                          </div>
                          <div class="events__event__info">
                            <h3 v-html="event.title.rendered">
                            </h3>
                            <div class="events__event__info__cloud">
                              <img
                                src="/static/cdn/location_wqviie.svg">
                              <span v-html="event.excerpt.rendered"> </span>
                            </div>
                          </div>
                        </router-link>
                      </div>

                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>

          <!-- SIDE PAGE -->
          <div class="col-md-3 col-xs-12">
            <side-bare></side-bare>
          </div>
        </div>
      </div>

    </div>
  </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import global from '@/mixins/global';
  import GPost from '@/mixins/posts';

  export default {
    mixins: [global,GPost],

    data() {
      return {
        events: undefined,
        pastEvents: [],
        UpComingEvents: [],
      }
    },
   async created() {
     await this.getCategories();
     await this.getPosts();
     await this.getEvents();
    },
    methods: {

 
  
      
     async getEvents() {
        var $this = this;
       return axios.get(this.proxyUrl + 'http://news.mobilityintel.com/wp-json/wp/v2/events?filter[orderby]=date&order=asc', {
            headers: {
              'Content-Type': 'application/json'
            }
          }, ).then(function (response) {
            $this.events = response.data;
            $this.getPastEvents();
            $this.getUpComingEvents();
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getPastEvents() {
        this.pastEvents = [];
        // if( this.events){
        this.events.forEach(element => {
          var date = (new Date(element.date).getTime());
          var currentDate = new Date().getTime();
          if (date < currentDate) {
             console.log('getPastEvents');

            console.log('element.date',date);
            console.log('currentDate',currentDate);
            this.pastEvents.push(element);
          }
        });
        // }
      },
      getUpComingEvents() {
        console.log('getUpComingEvents');
        this.UpComingEvents = [];
        // if( this.events){
        this.events.forEach(element => {
          var date = (new Date(element.date).getTime());
          var currentDate = new Date().getTime();
          if (date > currentDate) {
              console.log('element.date',date);
            console.log('currentDate',currentDate);
            this.UpComingEvents.push(element);
          }
        });
        console.log(this.UpComingEvents);
        // }
      },

    }


  }

</script>

<style lang="scss">
  .news {
    @import "../../../assets/style/flexbox";
  }

  @import "../style";

  .posts_section {
    margin-right: 31px;
  }

  .sc {
    text-transform: capitalize;
  }

  .bg_inner_page {
    background-size: cover;
    width: 100%;
    height: 171px;
    margin-top: 25px;
    margin-bottom: 41px;
  }

</style>
<style scoped>
  .date_icon {
    display: block;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/News/EventsPage/index.vue